/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type COMMENT_STATUS = "APPROVED" | "NONE" | "PREMOD" | "REJECTED" | "SYSTEM_WITHHELD" | "%future added value";
export type COMMENT_VIEWER_ACTION = "APPROVE" | "CREATE" | "EDIT" | "REJECT" | "%future added value";
export type TAG = "ADMIN" | "EXPERT" | "FEATURED" | "MEMBER" | "MODERATOR" | "QUESTION" | "REVIEW" | "STAFF" | "UNANSWERED" | "%future added value";
export type CommentContainer_comment = {
    readonly id: string;
    readonly author: {
        readonly id: string;
        readonly username: string | null;
        readonly avatar: string | null;
        readonly badges: ReadonlyArray<string> | null;
        readonly featuredCommenter: boolean | null;
        readonly newCommenter: boolean | null;
    } | null;
    readonly parent: {
        readonly id: string;
        readonly author: {
            readonly username: string | null;
        } | null;
    } | null;
    readonly body: string | null;
    readonly createdAt: string;
    readonly status: COMMENT_STATUS;
    readonly rating: number | null;
    readonly editing: {
        readonly edited: boolean;
        readonly editableUntil: string | null;
    };
    readonly tags: ReadonlyArray<{
        readonly code: TAG;
    }>;
    readonly pending: boolean | null;
    readonly lastViewerAction: COMMENT_VIEWER_ACTION | null;
    readonly deleted: boolean | null;
    readonly actionCounts: {
        readonly reaction: {
            readonly total: number;
        };
    };
    readonly viewerActionPresence: {
        readonly dontAgree: boolean;
        readonly flag: boolean;
    } | null;
    readonly hasTraversalFocus: boolean | null;
    readonly seen: boolean | null;
    readonly canReply: boolean;
    readonly " $fragmentRefs": FragmentRefs<"CaretContainer_comment" | "EditCommentFormContainer_comment" | "MediaSectionContainer_comment" | "ReactionButtonContainer_comment" | "ModerationRejectedTombstoneContainer_comment" | "ReplyCommentFormContainer_comment" | "ReportButton_comment" | "ReportFlowContainer_comment" | "UsernameContainer_comment" | "UsernameWithPopoverContainer_comment" | "UserTagsContainer_comment" | "ArchivedReportFlowContainer_comment">;
    readonly " $refType": "CommentContainer_comment";
};
export type CommentContainer_comment$data = CommentContainer_comment;
export type CommentContainer_comment$key = {
    readonly " $data"?: CommentContainer_comment$data;
    readonly " $fragmentRefs": FragmentRefs<"CommentContainer_comment">;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any), v1 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "username",
        "storageKey": null
    } as any);
    return {
        "argumentDefinitions": [
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "refreshStream"
            }
        ],
        "kind": "Fragment",
        "metadata": null,
        "name": "CommentContainer_comment",
        "selections": [
            (v0 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    (v1 /*: any*/),
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "avatar",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "badges",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "featuredCommenter",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "newCommenter",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "parent",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "author",
                        "plural": false,
                        "selections": [
                            (v1 /*: any*/)
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "body",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rating",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "EditInfo",
                "kind": "LinkedField",
                "name": "editing",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "edited",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "editableUntil",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "Tag",
                "kind": "LinkedField",
                "name": "tags",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "code",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "deleted",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "ActionCounts",
                "kind": "LinkedField",
                "name": "actionCounts",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "ReactionActionCounts",
                        "kind": "LinkedField",
                        "name": "reaction",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "total",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "ActionPresence",
                "kind": "LinkedField",
                "name": "viewerActionPresence",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "dontAgree",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "flag",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "seen",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "canReply",
                "storageKey": null
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "CaretContainer_comment"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EditCommentFormContainer_comment"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "MediaSectionContainer_comment"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ReactionButtonContainer_comment"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ModerationRejectedTombstoneContainer_comment"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ReplyCommentFormContainer_comment"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ReportButton_comment"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ReportFlowContainer_comment"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "UsernameContainer_comment"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "UsernameWithPopoverContainer_comment"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "UserTagsContainer_comment"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ArchivedReportFlowContainer_comment"
            },
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "pending",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lastViewerAction",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasTraversalFocus",
                        "storageKey": null
                    }
                ]
            }
        ],
        "type": "Comment",
        "abstractKey": null
    } as any;
})();
(node as any).hash = 'ea4fef7149c5f44205a8e21c9de58c41';
export default node;
